import React, { Fragment } from 'react';
import {
  IonList,
  IonLoading,
  IonItem,
  IonThumbnail,
  IonLabel,
  IonListHeader,
} from '@ionic/react';
import { connect } from 'react-redux';
import * as actionCreator from '../store/actions/inventoryActions';
import _ from 'lodash';

import NoData from '../components/NoData';

const TopSellingItemsContainer: React.FC = (props: any) => {
  const { list, updatedItems, user } = props;
  //sort by number of sales
  let filteredList = _.sortBy(list, 'saleCount')
    .reverse()
    .slice(0, 2)
    .filter((item: any) => item.saleCount >= 1);

  if (updatedItems === false) {
    props.onGetItems(user.email);
    return <IonLoading isOpen={true} message={'Please wait...'} />;
  }

  setTimeout(() => {
    props.onResetStatus();
  }, 3000);

  return (
    <Fragment>
      <IonList>
        <IonListHeader>Top Selling Items</IonListHeader>
        {_.isEmpty(filteredList) && <NoData />}
        {filteredList.map((item: any) => (
          <IonItem key={item._id} routerLink={'/item/' + item._id}>
            <IonThumbnail slot="start" border-radius="0">
              <img src={item.imageURL} alt="item" />
            </IonThumbnail>
            <IonLabel>
              <h4>
                <b>
                  <p>{item.name}</p>
                </b>
              </h4>
              <h4>
                <p>KES {item.price}</p>
              </h4>
              <p>{item.quantity_available} in stock</p>
            </IonLabel>
          </IonItem>
        ))}
      </IonList>
    </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    list: state.inventoryReducer.list,
    ordersList: state.ordersReducer.list,
    updatedItems: state.inventoryReducer.updatedItems,
    user: state.userReducer.user,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onRemoveItem: (payload: {}) => dispatch(actionCreator.removeItem(payload)),
    onResetStatus: () => dispatch(actionCreator.resetStatus()),
    onGetItems: (payload: {}) => dispatch(actionCreator.getItems(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopSellingItemsContainer);
